import { List, ListItem, Stars, Typography } from 'darrius';
import { type IRatingReturn } from '../../../modules/profile/shared/pageProps/getRatingProps/@interfaces';

import styles from './ProfileRating.module.scss';
interface IProfileRatingProps {
  rating: IRatingReturn;
}

export const ProfileRating = ({ rating }: IProfileRatingProps) => {
  if (!rating) return null;

  return (
    <section className={`${styles.section}`} id={rating.id}>
      <Typography.Subtitle size="l" className={styles.subtitle}>
        {rating.title}
      </Typography.Subtitle>
      <div
        className={`${styles['rating-about']} no-margin-bottom center-items`}
      >
        <Stars
          size="small"
          rating={rating.total}
          quantity={rating.items.length}
          showText={true}
        />
        <Typography.Text
          className={styles.text}
        >{`${rating.quantity} avaliações`}</Typography.Text>
      </div>
      <List className={styles.rating__list}>
        {rating.items.map((item) => (
          <ListItem key={item.star} className="center-items no-margin-bottom">
            <Stars quantity={item.quantity} size="small" />
            <Typography.Text
              className={styles.text}
            >{` ${item.star} estrelas`}</Typography.Text>
            <Typography.Text
              className={styles.text}
            >{`: ${item.quantity} avaliações`}</Typography.Text>
          </ListItem>
        ))}
      </List>
    </section>
  );
};
